import { useMissionControlContext } from 'modules/missionControl/contexts/MissionControlContext';
import {
  GoalsDashboardEmptyState,
  GoalsDashboardErrorState,
  GoalsDashboardDataState,
  GoalsDashboardLoadingState,
} from './GoalsDashboardStates';
import { useGoalsDashboardState } from './hooks/useGoalsDashboardState';

export const GoalsDashboardContents = () => {
  const {
    userGoalsQuery: { goals = [], refetch },
  } = useMissionControlContext();
  const {
    isLoadingState,
    isErrorState,
    isEmptyState,
    isDataState,
    hasGoalsInProject,
    canCreateGoals,
  } = useGoalsDashboardState();

  switch (true) {
    case isLoadingState:
      return <GoalsDashboardLoadingState />;

    case isErrorState:
      return <GoalsDashboardErrorState refetch={refetch} />;

    case isEmptyState:
      return (
        <GoalsDashboardEmptyState
          canCreateGoals={canCreateGoals}
          hasGoalsInProject={hasGoalsInProject}
        />
      );

    case isDataState:
      return <GoalsDashboardDataState goals={goals} />;

    default:
      return <GoalsDashboardErrorState refetch={refetch} />;
  }
};
